import React from 'react'
import Modal from './Modal'
import ModalBoardContext from './ModalBoardContext'

type Props = React.ComponentProps<typeof Modal> & {
  boardId: number
}

const ModalWithBoardContext: React.FC<Props> = ({
  children,
  boardId,
  ...props
}) => {
  return (
    <Modal
      {...props}
    >
      <ModalBoardContext boardId={boardId}>
        {children}
      </ModalBoardContext>
    </Modal>
  )
}

export default ModalWithBoardContext
